import styled from '@emotion/styled';
import { mq } from '~/lib';
import { Grid } from '~/shared/components/Grid/Grid';
import { breakpointsRaw } from '~/theme/breakpoints';

export const StyledGiftCardContainer = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: theme.colors.yellowUltraLight,
    width: '100%',
    paddingTop: theme.space[9],
    paddingBottom: theme.space[9],
}));

export const StyledGrid = styled(Grid)<{ isExpDate?: boolean }>(({ isExpDate, theme }) => ({
    width: '100%',
    marginBottom: '10px',
    [mq(0, breakpointsRaw.md)]: {
        gridTemplateColumns: !isExpDate ? '1fr' : '1fr auto',
        rowGap: theme.space[5],
        gridAutoFlow: 'row',
    },
}));
